export function setFavicon(link) {
  const favicon = document.querySelector('link[rel="icon"]');
  if (favicon) {
    favicon.href = link;
  } else {
    const newFavicon = document.createElement('link');
    newFavicon.rel = 'icon';
    newFavicon.href = link;
    document.head.appendChild(newFavicon);
  }
}

export function formatPrice(price) {
  return price.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

export function formatInstallments(price, installments = 12) {
  const installmentValue = (price / installments).toFixed(2);
  return `${installments}x de R$${installmentValue.replace('.', ',')}`;
}
